import { Link } from 'react-router-dom'

export default function ForgotPasswordPage() {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 text-center">Password dimenticata</h2>
      <p className="mt-2 text-sm text-gray-600 text-center">
        Inserisci la tua email per reimpostare la password
      </p>
      <p className="mt-8 text-center text-gray-500">
        Recupero password - da implementare
      </p>
      <p className="mt-6 text-center text-sm text-gray-600">
        <Link to="/login" className="text-primary-600 hover:text-primary-500 font-medium">
          Torna al login
        </Link>
      </p>
    </div>
  )
}
